import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, VERSION, ViewChild, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule  } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { DocumentsService } from '../../services/documents/documents.service';
import { Claimant } from '../../models/claimant';
import { Authenticate } from '../../models/authenticate';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';


@Component({
  selector: 'app-ltmdoc-claimants',
  templateUrl: './ltmdoc.html',
  styleUrls: ['./ltmdoc.css'],
  imports: [ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule],
  providers: [provideNgxMask()], // Provide at the component level
})
export class LTMDOC implements OnInit {
  @ViewChild('listofFiles') tableRef: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;

  LTMDOCForm: FormGroup;
  clicked: boolean = false;
  submitClicked: boolean = false;
  showMessage: boolean = false;
  submitted: boolean = false;

  response: string | undefined;
  showDivFileUploadMessage: boolean = false;

  supportingDocuments: any = [];
  authenticatedUser: Authenticate;
  public claimant: Claimant;
  public errorMessage: string = '';
  public showError: boolean;
  public submittedClaim: Claimant;
  constructor(
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private documentsService: DocumentsService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private storage: LocalStorageService) { }

  ngOnInit() {
    this.authenticatedUser = this.storage.retrieve('authenticatedUser');
    this.LTMDOCForm = this.fb.group({
      name: [this.authenticatedUser.name],
      claimNumber: [this.authenticatedUser.claimNumber],
      flag: ['LTMDOC'],
      /*signature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],*/
      /*googleRecaptchaToken: ['', Validators.compose([Validators.required])]*/
    });
  }

  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }

  // convenience getter for easy access to form fields
  get f() { return this.LTMDOCForm.controls; }

  onBlur(event) {
    if (event.target.value !== '')
      event.target.value = parseFloat(event.target.value).toFixed(2)
  }


  getFileDetails(e) {
    for (let i = 0; i < e.target.files.length; i++) {
      this.supportingDocuments.push(e.target.files[i]);
      this.showDivFileUploadMessage = false;
    }
  }
  removeRow(i: number) {
    this.supportingDocuments.splice(i, 1);
    this.fileInput.nativeElement.value = null;
  }
  onSubmit() {
    this.submitted = true;
    if (this.LTMDOCForm.invalid) {
      return;
    }
    if (this.supportingDocuments.length == 0) {
      this.showDivFileUploadMessage = true;
      return;
    }
    this.submitClicked = true;
    this.clicked = true;
    /*const claimant = this.LTMDOCForm.value;*/

    this.spinner.show();
    this.SubmitDocuments(this.authenticatedUser.claimNumber);
  }



  //CreateClaimant(claimant: Claimants) {
  //  this.claimantService.createClaimant(claimant).subscribe(res => {
  //    this.submittedClaim = res;
  //    this.SubmitDocuments(this.submittedClaim.claimNumber);
  //  });
  //}

  SubmitDocuments(claimNumber: string) {
    this.documentsService.submitDocuments(claimNumber, this.supportingDocuments).subscribe({
      next: (res) => {
        this.storage.store('claimant', {
          claimNumber: this.authenticatedUser.claimNumber
        });
        this.LTMDOCForm.reset();
        this.spinner.hide();
        this.router.navigate(['/complete']);
      },
      error: err => {
        this.spinner.hide();
        console.group('Document submission failed');
        console.log('Status:', err.status);
        console.log('Error:', err.error);
        console.groupEnd();
      }
    });
    //this.storage.store('claimant', this.submittedClaim);
    //// this.dataSaved = true;
    //// this.submitted = false;
    //// this.notSubmitted = false;
    //// this.message = "Record Saved Successfully";
    //this.LTMDOCForm.reset();
    //this.spinner.hide();
    //this.router.navigate(['/complete']);
  }

}
